module.exports = __webpack_public_path__ + "files/2ee5061a24e243194b21783f51ed0b3f.svg";